/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import PropTypes from 'prop-types';
import CreatePaperSetupModal from '../modal/CreatePaperSetupModal';
import { ModalContext } from 'App';
import * as actions from '../../cms/action';
import * as c from '../../cms/constant';

const Aside = ({
  paperSetup,
  getPaperList,
  defaultPaperData,
  parsedData,
  cmsId,
}) => {
  const setModal = useContext(ModalContext);
  const defaultSettings = JSON.parse(
    _.get(defaultPaperData, 'attributes.body') || '{}'
  );
  const defaultPaperSize = _.get(defaultSettings, 'paper_size', '');
  const defaultPaperOrientation = _.get(
    defaultSettings,
    'paper_orientation',
    ''
  );
  const defaultPaperMargin = _.get(defaultSettings, 'paper_margin', '');
  const defaultTop = _.get(defaultSettings, 'top', 0);
  const defaultBottom = _.get(defaultSettings, 'bottom', 0);
  const defaultLeft = _.get(defaultSettings, 'left', 0);
  const defaultRight = _.get(defaultSettings, 'right', 0);
  const defaultPaperSetup = {
    paper_size: _.get(paperSetup, 'paper_size', defaultPaperSize),
    paper_orientation: _.get(
      paperSetup,
      'paper_orientation',
      defaultPaperOrientation
    ),
    paper_margin: _.get(paperSetup, 'paper_margin', defaultPaperMargin),
    top: _.get(paperSetup, 'top', defaultTop),
    bottom: _.get(paperSetup, 'bottom', defaultBottom),
    left: _.get(paperSetup, 'left', defaultLeft),
    right: _.get(paperSetup, 'right', defaultRight),
  };

  useEffect(() => {
    getPaperList({ type: 'BUSINESS_PERMIT_PAPER_SETUP' });
  }, []);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreatePaperSetupModal
          parsedData={parsedData}
          defaultPaperSetup={defaultPaperSetup}
          cmsId={cmsId}
        />
      ),
      title: 'Business Permit Paper Setup',
      modalSize: 'modal-sm',
    });
  };

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-between gap-2 mb-2"
        style={{ gap: '10px' }}
      >
        <h5 className="m-0 font-weight-bold">Paper Setup</h5>
        <button
          type="button"
          className="btn btn-sm bg-primary text-white"
          onClick={handleAddModal}
        >
          Update
        </button>
      </div>

      <table className="table table-bordered table-sm mb-0">
        <tbody>
          <tr>
            <td className="bg-light" colSpan={2}>
              <small>Paper Size</small>
            </td>
            <td colSpan={2}>
              <span className="badge badge-primary">
                {_.get(defaultPaperSetup, 'paper_size')}
              </span>
            </td>
          </tr>
          <tr>
            <td className="bg-light" colSpan={2}>
              <small>Paper Orientation</small>
            </td>
            <td colSpan={2}>
              {_.capitalize(_.get(defaultPaperSetup, 'paper_orientation'))}
            </td>
          </tr>
          <tr>
            <td className="bg-light" colSpan={2}>
              <small>Margin Unit</small>
            </td>
            <td colSpan={2}>
              <span className="badge badge-primary">
                {_.get(defaultPaperSetup, 'paper_margin')}
              </span>
            </td>
          </tr>
          <tr>
            <td className="bg-light">
              <small>Top</small>
            </td>
            <td>{_.get(defaultPaperSetup, 'top')}</td>
            <td className="bg-light">
              <small>Bottom</small>
            </td>
            <td>{_.get(defaultPaperSetup, 'bottom')}</td>
          </tr>
          <tr>
            <td className="bg-light">
              <small>Left</small>
            </td>
            <td>{_.get(defaultPaperSetup, 'left')}</td>
            <td className="bg-light">
              <small>Right</small>
            </td>
            <td>{_.get(defaultPaperSetup, 'right')}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

Aside.propTypes = {
  paperSetup: PropTypes.instanceOf(Object).isRequired,
  defaultPaperData: PropTypes.instanceOf(Object).isRequired,
  parsedData: PropTypes.instanceOf(Object).isRequired,
  cmsId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  defaultPaperData: (_.get(api, `${c.GET_PAPER_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(Aside);
